export const theme = {
  token: {
    colorPrimary: "#009347",
    colorBgLoginLayout: "#DFE7F8",
    colorText: "#737373",
    borderRadius: 6,
  },
};
